// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IndustryHint = zod.object({
  "name": zod.string(),
  "reason": zod.literal("inactive")
});

export type IndustryHint = zod.input<typeof IndustryHint>;
export type IndustryHintOutput = zod.output<typeof IndustryHint>;
